import { useEffect, useState } from 'react'
import { ErrorLabel } from '../Label/ErrorLabel'

type CircularTimerProps = {
  targetTime: string
  size?: number
  strokeWidth?: number
  className?: string
}

export const LoadingTimer: React.FC<CircularTimerProps> = ({
  targetTime,
  size = 120,
  strokeWidth = 10,
  className = '',
}) => {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius

  const [progress, setProgress] = useState(1)
  const [timeStr, setTimeStr] = useState('')
  const [expired, setExpired] = useState(false)

  useEffect(() => {
    const end = new Date(targetTime).getTime()
    const start = Date.now()
    const totalDuration = end - start

    const interval = setInterval(() => {
      const now = Date.now()
      const remaining = end - now

      if (remaining <= 0) {
        setProgress(0)
        setTimeStr('00:00:00')
        setExpired(true)
        clearInterval(interval)
        return
      }

      setProgress(remaining / totalDuration)

      const totalSeconds = Math.floor(remaining / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      setTimeStr(
        `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(
          seconds
        ).padStart(2, '0')}`
      )
    }, 1000)

    return () => clearInterval(interval)
  }, [targetTime])

  return (
    <div className={className} style={{ display: 'inline-block', textAlign: 'center' }}>
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke='#d6d6d6'
          strokeWidth={strokeWidth}
          fill='none'
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke='#3e98c7'
          strokeWidth={strokeWidth}
          fill='none'
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - progress)}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dashoffset 1s linear' }}
        />
        <text
          x='50%'
          y='50%'
          textAnchor='middle'
          dominantBaseline='middle'
          fontSize={size / 7}
          fontWeight='bold'
          fill={expired ? '#d6d6d6' : '#3e98c7'}
        >
          {timeStr}
        </text>
      </svg>

      {expired && (
        <ErrorLabel className='mt-2 fw-bold'>
          Nosso profissional está concluindo o atendimento anterior e já irá iniciar a sua consulta.
          Agradecemos por aguardar!
        </ErrorLabel>
      )}
    </div>
  )
}
